import { ReactNode } from 'react'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import CustomDropdown from 'components/ui/CustomDropdown'

interface TableActionsBaseProps {
  selected: number
  onRemoveSelected(): void
  label: ReactNode
  removeSelectedLabel: ReactNode
}

export const ActionsCommon = ({
  selected,
  onRemoveSelected,
  label,
  removeSelectedLabel,
}: TableActionsBaseProps) => (
  <>
    <CustomDropdown id="dropdown-manage" alignRight>
      <CustomDropdown.Toggle
        id="dropdown-manage-toggle"
        bsPrefix="noCaret"
        variant={'secondary'}
      >
        {label} <FontAwesomeIcon icon={faChevronDown} />
      </CustomDropdown.Toggle>
      <CustomDropdown.Menu>
        <CustomDropdown.Item
          disabled={!selected}
          onClick={() => {
            onRemoveSelected()
          }}
        >
          {removeSelectedLabel}
        </CustomDropdown.Item>
      </CustomDropdown.Menu>
    </CustomDropdown>
  </>
)
